export default "__VITE_ASSET__CE3z1R2G__"